<template>
  <div class="Price-List">
    <h4>{{ label }}</h4>
    <select class="test-select_list_price form-control" @change="updateValue($event.target.value)">
      <template v-for="(item, index) in values">
          <option :key="index" :disabled="item.is_disabled" :selected="index == defaultIndex" :value="item.is_disabled ? '' : index">{{ item.value | formatCurrency(currency) }} - {{ item.type }}</option>
      </template>
    </select>
  </div>
</template>

<script>
  export default {
    props: ['values', 'label', 'currency'],

    computed: {
      defaultIndex () {
        return this.values.findIndex((e) => {
          return !e.is_disabled;
        });
      }
    },

    methods: {
      updateValue (index) {
        let payload = this.values[index];
        payload.label = this.label;

        this.$emit('change', payload);
      },

      initValue () {
        if (this.defaultIndex >= 0) {
          this.updateValue(this.defaultIndex);
        }
      }
    },

    created () {
      this.initValue();
    }
  };
</script>

<style scoped>
  h4 {
    margin: 0;
    padding: 0;
    font-size: 1em;
    margin-bottom: 1.5%;
    font-family: 'Roboto';
    font-weight: 400;
  }

  .Price-List {
    font-family: 'Roboto';
    text-transform: uppercase;
    font-weight: 500;
    color: #737373;
    margin-bottom: 5%;
  }

  select {
    font-family: 'Roboto';
    font-weight: 300;
    display: block;
    min-width: 40%;
    height: 39px;
    padding: 6px 12px;
    font-size: 16px;
    line-height: 1.42857143;
    color: #737373;
    background-color: #fff;
    background-image: none;
    border: 2px solid #737373;
    border-radius: 4px;
    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
    -webkit-transition: border-color ease-in-out .15s,-webkit-box-shadow ease-in-out .15s;
    -o-transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
    transition: border-color ease-in-out .15s,box-shadow ease-in-out .15s;
  }
</style>



// WEBPACK FOOTER //
// price-list.vue?3b899964